<gp-dropdown-select [ngClass]="{ 'font-weight-bold': isCustomPopulation }"
                    [forceDisplayValue]="selectedPopulationDisplayValue()"
                    (selected)="onSelect($event)"
                    class="context-select"
                    test-id="context-population-dropdown">
  <gp-dropdown-option *ngFor="let population of populations" [ngValue]="population">
    {{ population.transId | translate }}
  </gp-dropdown-option>
</gp-dropdown-select>
